<template>
  <div>
    <button class="btn-export-pdf" @click="exportPdf()">Export pdf</button>

    <div class="row" id="pdfDom">
      <section class="pdf-item">
        <rating-system
          :program-info="programInfo"
          :programSummaryRating="programSummaryRating"
        ></rating-system>
      </section>

      <section class="pdf-item">
        <greetings></greetings>
      </section>

      <section class="pdf-item">
        <overall
          :program-info="programInfo"
          :programSummaryRating="programSummaryRating"
        ></overall>
      </section>

      <section class="pdf-item">
        <category
          :programInfo="programInfo"
          :programCategoryRatings="programCategoryRatings"
        ></category>
      </section>

      <template
        v-for="(criterionCategoryRating,
        criterionCategoryRatingIndex) in programCategoryRatings"
      >
        <section
          class="pdf-item"
          v-if="
            criterionCategoryRating.criteria &&
              criterionCategoryRating.criteria.length <= 7
          "
          :key="'criterionCategoryRating-' + criterionCategoryRatingIndex"
        >
          <criterion-rating
            :programCategoryRating="criterionCategoryRating"
            :order-number="criterionCategoryRatingIndex + 1"
            :program-info="programInfo"
          ></criterion-rating>
        </section>

        <template v-else>
          <section
            class="pdf-item"
            :key="'criterionCategoryRating-wh-' + criterionCategoryRatingIndex"
          >
            <criterion-rating-header
              :programCategoryRating="criterionCategoryRating"
              :order-number="criterionCategoryRatingIndex + 1"
              :program-info="programInfo"
            ></criterion-rating-header>
          </section>

          <section
            v-if="criterionCategoryRatingIndex + 1 !== 6"
            class="pdf-item pdf-item-wth"
            :key="'criterionCategoryRating-wth-' + criterionCategoryRatingIndex"
          >
            <criterion-rating-without-header
              :programCategoryRating="criterionCategoryRating"
              :order-number="criterionCategoryRatingIndex + 1"
              :program-info="programInfo"
            ></criterion-rating-without-header>
          </section>
        </template>
      </template>
      <section class="pdf-item">
        <basic-facts
          :program-info="programInfo"
          :programCategoryRating="programCategoryRatings"
        ></basic-facts>
      </section>

      <section class="pdf-item">
        <about-upm-pdf></about-upm-pdf>
      </section>
    </div>
  </div>
</template>

<script>
import Greetings from "./Greetings";
import Overall from "./Overall";
import Category from "./Category";
import BasicFacts from "./BasicFacts";
import { ProgramService } from "../../../services/program.service";
import { NationService } from "../../../services/nation.service";
import CriterionRating from "./CriterionRating";
import RatingSystem from "./RatingSystem";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import { mapMutations } from "vuex";
import AboutUpmPdf from "./AboutUpmPdf";
import CriterionRatingWithoutHeader from "./CriterionRatingWithoutHeader";
import CriterionRatingHeader from "./CriterionRatingHeader";

export default {
  name: "ExportPdfIndex",
  components: {
    CriterionRatingHeader,
    CriterionRatingWithoutHeader,
    AboutUpmPdf,
    RatingSystem,
    CriterionRating,
    BasicFacts,
    Category,
    Overall,
    Greetings
  },

  data() {
    return {
      programInfo: {},
      programSummaryRating: {},
      programCategoryRatings: [],
      htmlToPdfOptions: {
        margin: 0,

        filename: `certificate.pdf`,

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        },

        jsPDF: {
          programt: "px",
          format: "a4",
          orientation: "portrait"
        }
      }
    };
  },
  created() {
    this.getDetailProgram();
    this.getProgramSummaryRating();
    this.getProgramCategoryRating();
  },
  methods: {
    ...mapMutations({
      hideLoading: "HIDE_LOADING",
      showLoading: "SHOW_LOADING"
    }),
    async exportPdf() {
      this.showLoading();
      setTimeout(async () => {
        let pages = document.getElementsByClassName("pdf-item");
        await this.exportHTMLToPDF(pages)
          .then(() => {})
          .finally(() => {
            this.hideLoading();
          });
      }, 5000);
    },
    async exportHTMLToPDF(pages) {
      console.log("exportHTMLToPDF pages", pages);
      const opt = {
        margin: [0, 0],
        filename: "myfile.pdf",
        pagebreak: { mode: ["css", "legacy"], before: ".page-break-pdf" },
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 192,
          scale: 4,
          letterRendering: true,
          useCORS: true
        },
        jsPDF: { programt: "pt", format: "a4", orientation: "portrait" }
      };
      const doc = new jsPDF(opt.jsPDF);
      const pageSize = jsPDF.getPageSize(opt.jsPDF);
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        let contentWidth = (595 * 4) / 3;
        let contentHeight = page.clientHeight;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        // page offset
        let position = 0;
        let leftHeight = contentHeight;
        if (i != 0) {
          doc.addPage();
        }

        // L: Landscape, p: portrait; programt: in: inches, mm mm; canvas size: A3, A4, Leeter, [] (when the content is array, for custom size)
        const pageImage = await html2pdf()
          .from(page)
          .set(opt)
          .outputImg();
        if (leftHeight <= pageHeight) {
          doc.addImage(
            pageImage.src,
            "jpeg",
            opt.margin[0],
            opt.margin[1],
            pageSize.width,
            pageSize.height
          );
        } else {
          while (leftHeight > 0) {
            doc.addImage(pageImage.src, "jpeg", 0, position);

            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              doc.addPage();
            }
          }
        }
      }
      doc.save("program.pdf", { returnPromise: true });
    },
    async getDetailProgram() {
      let programInfo = await new ProgramService().getById(
        this.$route.params.id
      );
      let nation = await this.getNation(programInfo.country_alpha_two_code);
      this.programInfo = { ...programInfo, nation: nation };
    },
    async getProgramCategoryRating() {
      const response = await new ProgramService().getRatetingByProgramId(
        this.$route.params.id
      );
      if (!response) {
        return;
      }

      response.forEach(category => {
        category.star = category.star || null;
        category.weight = category.weight || 0;
        category.score = category.score || 0;
        category.extra = category.extra || "";
      });
      this.programCategoryRatings = response;
    },
    async getNation(country_alpha_two_code) {
      const nation = new NationService().getNation(country_alpha_two_code);
      if (!nation) {
        return;
      }
      return nation.data.name;
    },
    async getProgramSummaryRating() {
      const response = await new ProgramService().getProgramRatingSummaries(
        this.$route.params.id
      );
      if (!response) {
        return;
      }
      this.programSummaryRating = {
        weight: response.weight || 0,
        score: response.score || 0,
        star: response.star || 0,
        extra: response.extra || ""
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/program-pdf.scss";
</style>
